module.exports = __webpack_public_path__ + "static/media/nsd.1eb6f884.jpg";